import React, { useEffect } from 'react';
import { Card } from './ui/card';
import { Coffee, MapPin, ExternalLink } from 'lucide-react';

const CoffeeChat = () => {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="coffee-chat" className="py-20 bg-slate-950">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-4">
              <Coffee className="text-blue-500" size={48} />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Let&apos;s Grab Coffee
            </h2>
            <p className="text-slate-400 text-lg mb-6">
              Living in NYC and always happy to connect! Schedule a time to chat over coffee.
            </p>
            
            <div className="inline-flex items-center gap-2 bg-blue-950 px-6 py-3 rounded-lg border border-blue-800 mb-8">
              <MapPin className="text-blue-400" size={20} />
              <span className="text-white font-medium">Starbucks at 25th & Lex near Baruch College</span>
            </div>
          </div>

          <Card className="bg-slate-900 border-slate-800 p-8">
            <div className="mb-6 text-center">
              <h3 className="text-xl font-semibold text-white mb-2">Select a Time That Works for You</h3>
              <p className="text-slate-400 text-sm">
                Choose a convenient time slot from my calendar below
              </p>
            </div>

            {/* Calendly Inline Widget */}
            <div 
              className="calendly-inline-widget" 
              data-url="https://calendly.com/kushagrabhatia0303/30min?hide_gdpr_banner=1&background_color=1e293b&text_color=ffffff&primary_color=2563eb"
              style={{ minWidth: '320px', height: '700px' }}
            ></div>

            <div className="mt-6 text-center">
              <p className="text-slate-400 text-sm mb-3">
                Prefer to schedule directly on Calendly?
              </p>
              <a
                href="https://calendly.com/kushagrabhatia0303/30min"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
              >
                <ExternalLink size={16} />
                <span>Open in Calendly</span>
              </a>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default CoffeeChat;
